export default {
  methods: {
    calcSubtotal(index) {
      let subtotal = 0;
      setTimeout(() => {
        this.model[index].rows.forEach(item => {
          subtotal += item.total;
        });
        this.model[index].subtotal = subtotal;
        this.setQuotationTotal(null, index);
      }, 50);
    },
    setDeadLine(param) {
      if (param instanceof Date) {
        this.model.delivery_date = new Date(param);
        const duration = parseInt(this.model.duration_time || 0, 10);
        const deadLine = parseInt(param.getUTCDate(), 10) + duration;
        this.model.delivery_date.setDate(deadLine);
      }
    },
    setEntreeValue(index) {
      this.setPortionValue(index);
    },
    setPortionValue(index) {
      Object.keys(this.model[index].installments_by_types).map(paymentType => {
        this.model[index].installments_by_types[paymentType] =
        this.model[index].installments_by_types[paymentType]
          .map(payment => this.setParcelValue(payment, index));
        return paymentType;
      });
    },
    setParcelValue(payment, index) {
      // Formula = PV / (1 + i)**n -1 / (1+i)**n *i;
      if (payment.parcel < 1) payment.parcel = 1;

      if (payment.entree_type === 'pct' && payment.entree_value > 100) {
        payment.entree_value = 100;
      }

      let entreeValue = parseFloat(payment.entree_value);
      if (payment.entree_type === 'pct') {
        entreeValue = this.model[index].total * (payment.entree_value / 100);
      }
      const pv = this.model[index].total - entreeValue;
      if (payment.payment_type === 'forward') {
        const tax = this.$store.state.settings.settings.tax / 100;
        const taxPlusParcel = (1 + tax) ** payment.parcel;
        payment.parcel_value = pv / ((taxPlusParcel - 1) / (taxPlusParcel * tax));
        payment.total = (payment.parcel_value * payment.parcel) + entreeValue;
        return payment;
      }
      payment.total = this.model[index].total;
      payment.parcel_value = pv / payment.parcel;
      return payment;
    },
    setQuotationDiscount(value, index) {
      const discount = this.model[index].subtotal - this.model[index].total;
      if (this.model[index].discount_type === 'pct') {
        this.model[index].discount_type = 'value';
      }
      this.model[index].discount = discount;
      this.setPortionValue(index);
    },
    setQuotationTotal(_, index) {
      if (this.model[index].discount_type === 'pct' && this.model[index].discount > 100) {
        this.model[index].discount = 100;
      }
      this.model[index].discount = this.model[index].discount || 0;
      let total = this.model[index].subtotal - this.model[index].discount;
      if (this.model[index].discount_type === 'pct') {
        total = this.model[index].subtotal * ((100 - this.model[index].discount) / 100);
      }
      this.model[index].total = total;
      this.setEntreeValue(index);
    },
    setTotal(item, index) {
      // eslint-disable-next-line
      item.total =  Number(item.value) * Number(item.quantity);
      this.calcSubtotal(index);
    },
    setUnitValor(item, index) {
      // eslint-disable-next-line
      item.value = item.total / item.quantity;
      this.calcSubtotal(index);
    },
  },
};
